var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-breadcrumb',{attrs:{"separator":"/"}},_vm._l((_vm.dataList),function(item){return _c('el-breadcrumb-item',{key:item.label},[(item.path)?_c('a',{attrs:{"href":item.path}},[_vm._v(_vm._s(item.label))]):[_vm._v(_vm._s(item.label))]],2)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }